import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { BaseComponent } from './base/base.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FooterComponent } from './footer/footer.component';
import { TranslateModule } from '@ngx-translate/core';

import { ContentAnimateDirective } from '../../core/content-animate/content-animate.directive';

import {
  NgbDropdownModule,
  NgbCollapseModule,
  NgbOffcanvas,
  NgbOffcanvasConfig,
} from '@ng-bootstrap/ng-bootstrap';

import { FeatherIconModule } from '../../core/feather-icon/feather-icon.module';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

import { NgSelectModule } from '@ng-select/ng-select';
import { NotificationsComponent } from './navbar/notifications/notifications.component';
import { SharedModule } from 'src/app/core/shared/shared.module';
import { AppLoaderComponent } from './common/app-loader/app-loader.component';
import { DocumentationComponent } from './documentation/documentation.component';

@NgModule({
  declarations: [
    BaseComponent,
    NavbarComponent,
    SidebarComponent,
    FooterComponent,
    ContentAnimateDirective,
    NotificationsComponent,
    AppLoaderComponent,
    DocumentationComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    NgbDropdownModule,
    NgbCollapseModule,
    PerfectScrollbarModule,
    FeatherIconModule,
    NgSelectModule,
    SharedModule,
    TranslateModule,
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    {
      provide: NgbOffcanvasConfig,
      useValue: { backdrop: 'static', keyboard: false, position: 'start' },
    },
    NgbOffcanvas,
  ],
})
export class LayoutModule {}
